import { Component, Input, OnInit } from '@angular/core';
import {
  FormControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { AiPromptArgument } from 'src/app/core/models/ai-prompt-argument';

@Component({
    selector: 'ai-prompt-arguments-form',
    templateUrl: './ai-prompt-arguments-form.component.html',
    styleUrl: './ai-prompt-arguments-form.component.less',
    standalone: false
})
export class AiPromptArgumentsFormComponent implements OnInit {
  argumentsForm: UntypedFormGroup;
  @Input() promptArguments: AiPromptArgument[] = [];

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    const argumentsGroup: any = {};

    this.promptArguments.forEach((argument) => {
      argumentsGroup[argument.name] = argument.required
        ? new FormControl('', Validators.required)
        : new FormControl('');
    });

    this.argumentsForm = this.fb.group(argumentsGroup);
  }

  emptyArgument(argumentName: string): boolean {
    if (this.argumentsForm.controls[argumentName].value) {
      return false;
    }
    return this.argumentsForm.controls[argumentName].errors?.required;
  }

  invalidForm(): boolean {
    const allArgumentsValid: boolean = this.promptArguments.every((argument) =>
      argument.required
        ? this.argumentsForm.controls[argument.name].valid
        : true
    );
    return (
      !(this.argumentsForm && this.argumentsForm.controls) ||
      !this.argumentsForm.dirty ||
      !allArgumentsValid
    );
  }
}
